window.addEventListener("load", function () {
  const images = document.querySelectorAll(".lazy-load-image");

  images.forEach((image) => {
    if (image.complete) {
      image.classList.add("loaded");
    } else {
      image.addEventListener("load", () => {
        image.classList.add("loaded");
      });
    }
  });
});
